module.exports = __webpack_public_path__ + "img/adn.20b41deb.webp";